import makeStyles from "@mui/styles/makeStyles";
import { error } from "./globalStyle";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "644px",
    boxSizing: "border-box",
    backgroundColor: "white",
    borderRadius: "12px !important",
    padding: "40px 24px",
    marginTop: "39px",

    "& .error": {
      textAlign: "center",
      margin: "1rem",
      marginBottom: 0,
      color: error,
      fontSize: "14px",
      whiteSpace: "pre-wrap",
    },

    "& .registrationHeader": {
      width: "100%",
      display: "flex",

      "& .headerLabel": {
        fontSize: "22px",
        fontWeight: "600",
        color: "#16161E",
        lineHeight: 1.2,
      },
    },

    "& .langSelect": {
      fontSize: "0.75rem",
      fontWeight: "300",
      borderRadius: "10px",
      width: "50px",
      height: "35px",

      "& .MuiSelect-select": {
        paddingRight: "1.125rem",
      },
      "& .MuiSelect-icon": {
        fontSize: "1rem",
        top: "calc(50% - 0.5rem)",
      },
    },
    "& .langSelectedRoot": {
      display: "flex",
      gap: "2px",
      position: "relative",
      left: "-5px",
    },
    "& .langSelected": {
      color: "#C6CBD9",
      fontWeight: "bold",
      fontSize: "12px",
    },
    "& .MuiSvgIcon-root": {
      display: "none",
    },

    "& .invitationBanner": {
      width: "100%",
      marginTop: "24px",
      padding: "12px 16px",
      backgroundColor: "#EAF3EE",
      borderRadius: "12px",
      color: "#32614F",
      fontSize: "14px",
      lineHeight: "1.4",

      "& strong": {
        fontWeight: "600",
      },
    },

    "& .establishmentHelp": {
      width: "100%",
      marginTop: "16px",
      color: "#656575",
      fontSize: "14px",
      lineHeight: "1.4",
      whiteSpace: "pre-wrap",

      "& strong": {
        fontWeight: "600",
      },
    },

    "& .sectionDivider": {
      width: "100%",
      marginTop: "16px",
      height: "1px",
      backgroundColor: "#F2F3F7",
    },

    "& .formContainer": {
      width: "100%",
      marginTop: "16px",

      "& .MuiFormHelperText-contained": {
        marginLeft: 0,
      },
    },

    "& .sirenLabel": {
      color: "#656575",
      fontSize: "14px",
      marginBottom: "16px",
    },

    "& .sirenField": {
      marginBottom: 0,
      width: "260px",

      "& .MuiInputBase-root": {
        borderRadius: "12px",
        width: "100%",
        fontSize: "14px",
      },
      "& .MuiOutlinedInput-input": {
        padding: "12px 16px",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E2E2EA",
      },
      "& .MuiInputBase-input": {
        color: "#9A9AAF",
        fontSize: "14px",
        "&::placeholder": {
          color: "#9A9AAF",
          opacity: 1,
        },
      },
    },

    "& .formBtnGrp": {
      marginTop: "16px",

      "& .MuiButton-root": {
        textTransform: "none",
        padding: "0.5rem 1.75rem",
        fontSize: "14px",

        "&.greenBtn": {
          backgroundColor: "#32614F",
          borderRadius: "30px",
        },
        "&.greenBtn:hover": {
          backgroundColor: "#54CC54",
          color: "#003A22",
        },
      },
    },
  },

  langItem: {
    fontSize: "0.75rem",
    fontWeight: 300,
    "&.MuiListItem-gutters": {
      padding: "0.125rem 0.75rem",
    },
    "&.hidden": {
      display: "none",
    },
  },
}));
